import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl } from "../../api/apiClient";
import {
  resetPasswordFailure,
  resetPasswordStart,
  resetPasswordSuccess,
} from "../../store/features/resetPassword/resetPasswordSlice";

const URL = buildApiUrl("/api/v1/reset-password");

const resetPasswordApi = async ({ email }) => {
  try {
    const response = await axios.post(URL, { email });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleResetPasswordSaga(action) {
  try {
    const data = yield call(resetPasswordApi, action.payload);
    yield put(resetPasswordSuccess(data));
  } catch (error) {
    yield put(resetPasswordFailure(error.message));
  }
}

export default function* resetPasswordSaga() {
  yield takeLatest(resetPasswordStart.type, handleResetPasswordSaga);
}
